import nyssma from './nyssma'

export default [...nyssma]
